import React from 'react';
import styled from 'styled-components';

export const StyledPicker = styled.div<{ color: string }>`
  position: relative;

  .color-preview {
    width: 24px;
    height: 24px;
    border-radius: 5px;
    margin: 3px 5px;
    border: 1px solid var(--color-smoke-100);
    border-radius: 4px;
    background: ${({ color }) => color || '#eee'};
  }

  .picker {
    display: none;
    position: absolute;
    top: 30px;
    left: 0;
    z-index: 9;
  }
  .picker.open {
    display: block;
  }
`;
